import { Flex, Separator } from "@radix-ui/themes";
import { ReactNode } from "react";
import styles from "../../../styles.module.scss";

interface InteractionListItemsProps {
  children: ReactNode;
  gap?: "1" | "2";
}

export const InteractionListItems = ({
  children,
  gap = "1",
}: InteractionListItemsProps) => {
  const childrenArray = Array.isArray(children) ? children : [children];

  return (
    <>
      {childrenArray.map((child, index) => (
        <Flex key={index} direction="column" gap={gap}>
          {child}
          {index !== childrenArray.length - 1 && (
            <Separator size="4" color="gray" className={styles.separator} />
          )}
        </Flex>
      ))}
    </>
  );
};
